import {
  DEVELOPER_DEVELOPERDETAIL_REQUEST,
  DEVELOPER_DEVELOPERDETAIL_SUCCESS,
  DEVELOPER_DEVELOPERDETAIL_FAIL,
  DEVELOPER_DEVELOPERDETAILEDIT_REQUEST,
  DEVELOPER_DEVELOPERDETAILEDIT_SUCCESS,
  DEVELOPER_DEVELOPERDETAILEDIT_FAIL,
  DEVELOPER_APPLY_REQUEST,
  DEVELOPER_APPLY_SUCCESS,
  DEVELOPER_APPLY_FAIL,
  DEVELOPER_APPLY_RESET,
  DEVELOPER_APPLYLIST_REQUEST,
  DEVELOPER_APPLYLIST_SUCCESS,
  DEVELOPER_APPLYLIST_FAIL,
  DEVELOPER_APPLYDETAIL_REQUEST,
  DEVELOPER_APPLYDETAIL_SUCCESS,
  DEVELOPER_APPLYDETAIL_FAIL,
  DEVELOPER_APPLYUPDATE_REQUEST,
  DEVELOPER_APPLYUPDATE_SUCCESS,
  DEVELOPER_APPLYUPDATE_FAIL,
  DEVELOPER_BUILDAPPLYLIST_REQUEST,
  DEVELOPER_BUILDAPPLYLIST_SUCCESS,
  DEVELOPER_BUILDAPPLYLIST_FAIL,
  DEVELOPER_BUILDAPPLY_REQUEST,
  DEVELOPER_BUILDAPPLY_SUCCESS,
  DEVELOPER_BUILDAPPLY_FAIL,
  DEVELOPER_LEARN_REQUEST,
  DEVELOPER_LEARN_SUCCESS,
  DEVELOPER_LEARN_FAIL,
  DEVELOPER_LEARN_RESET,
  DEVELOPER_LEARNLIST_REQUEST,
  DEVELOPER_LEARNLIST_SUCCESS,
  DEVELOPER_LEARNLIST_FAIL,
} from "../constants/developerConstants";

export const developerApplyReducer = (state = {}, action) => {
  switch (action.type) {
    case DEVELOPER_APPLY_REQUEST:
      return { loading: true };
    case DEVELOPER_APPLY_SUCCESS:
      return { loading: false, developerApply: action.payload };
    case DEVELOPER_APPLY_FAIL:
      return { loading: false, error: action.payload };
    case DEVELOPER_APPLY_RESET:
      return {};
    default:
      return state;
  }
};

export const developerDetailReducer = (state = { devDetail: {} }, action) => {
  switch (action.type) {
    case DEVELOPER_DEVELOPERDETAIL_REQUEST:
      return { loading: true, devDetail: {} };
    case DEVELOPER_DEVELOPERDETAIL_SUCCESS:
      return { loading: false, devDetail: action.payload };
    case DEVELOPER_DEVELOPERDETAIL_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const developerDetailEditReducer = (state = {}, action) => {
  switch (action.type) {
    case DEVELOPER_DEVELOPERDETAILEDIT_REQUEST:
      return { loading: true };
    case DEVELOPER_DEVELOPERDETAILEDIT_SUCCESS:
      return { loading: false, devDetail: action.payload };
    case DEVELOPER_DEVELOPERDETAILEDIT_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const developerApplyBuildReducer = (state = {}, action) => {
  switch (action.type) {
    case DEVELOPER_BUILDAPPLY_REQUEST:
      return { loading: true };
    case DEVELOPER_BUILDAPPLY_SUCCESS:
      return { loading: false, success: true };
    case DEVELOPER_BUILDAPPLY_FAIL:
      return { loading: false, error: action.payload };
    // case DEVELOPER_BUILDAPPLY_RESET:
    //   return {};
    default:
      return state;
  }
};

export const listBuildApplyReducer = (state = { applied: [] }, action) => {
  switch (action.type) {
    case DEVELOPER_BUILDAPPLYLIST_REQUEST:
      return { loading: true, applied: [] };
    case DEVELOPER_BUILDAPPLYLIST_SUCCESS:
      return {
        loading: false,
        applied: action.payload,
      };
    case DEVELOPER_BUILDAPPLYLIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const developerLearnReducer = (state = {}, action) => {
  switch (action.type) {
    case DEVELOPER_LEARN_REQUEST:
      return { loading: true };
    case DEVELOPER_LEARN_SUCCESS:
      return { loading: false, developerLearn: action.payload };
    case DEVELOPER_LEARN_FAIL:
      return { loading: false, error: action.payload };
    case DEVELOPER_LEARN_RESET:
      return {};
    default:
      return state;
  }
};
